export const buildCorporateTravellerProfileRequest = ({ contactDetails, travellers, userName, corporateCode  }) => {
  const allPassengers = [
    ...(travellers?.adults?.map((pax) => ({
      title: pax.title,
      firstName: pax.firstName,
      lastName: pax.lastName,
      dateOfBirth: pax.dob,
      paxType: "ADT",
      passportNumber: pax.passportNo,
      ffNo: pax.frequentFlyerNo || "",
      nationality: pax.nationality,
      issuingCountry: pax.issuingCountry,
      passportIssueDate: pax.issueDate,
      expiryDate: pax.expiryDate,
      isSaveTravellerInfo: pax.saveInfo || false,
      userName: pax.userName,
    })) || []),

    ...(travellers?.children?.map((pax) => ({
      title: pax.title,
      firstName: pax.firstName,
      lastName: pax.lastName,
      dateOfBirth: pax.dob,
      paxType: "CHD",
      passportNumber: pax.passportNo,
      ffNo: pax.frequentFlyerNo || "",
      nationality: pax.nationality,
      issuingCountry: pax.issuingCountry,
      passportIssueDate: pax.issueDate,
      expiryDate: pax.expiryDate,
      isSaveTravellerInfo: pax.saveInfo || false,
      userName: pax.userName,
    })) || []),

    ...(travellers?.infants?.map((pax) => ({
      title: pax.title,
      firstName: pax.firstName,
      lastName: pax.lastName,
      dateOfBirth: pax.dob,
      paxType: "INF",
      passportNumber: pax.passportNo,
      ffNo: pax.frequentFlyerNo || "",
      nationality: pax.nationality,
      issuingCountry: pax.issuingCountry,
      passportIssueDate: pax.issueDate,
      expiryDate: pax.expiryDate,
      isSaveTravellerInfo: pax.saveInfo || false,
      userName: pax.userName,
    })) || []),
  ];

  return {
      email: contactDetails.emailId,
      phoneCode: contactDetails.countryCode,
      phoneNumber: contactDetails.mobile,
      corporateCode: corporateCode,
      userName: userName,
      passengerDetails: allPassengers,
  };
};